import React from "react";
import { isWebpSupported } from "react-image-webp/dist/utils";
import { URL_CONFIG } from "../../../../_constants/Config/URL_CONFIG";
import Button from "../CommonComponents/Button";
import Card from "../CommonComponents/Card";
import HeadLines from "../CommonComponents/HeadLines";
import style from "./style.module.css";

import { eventTracker } from "../GATracker3.0/eventTracker";
import { CREATE_ACCOUNT_CLICKED } from "../GATracker3.0/constants";
import { isMobile } from "../helperFunc";
import { useLocation } from "react-router";

const CreateAccountWidget = (props) => {
  let pngImage = URL_CONFIG.IMG_URL + "arya2/farm_image.png";
  let desktopImage = URL_CONFIG.IMG_URL + "arya2/desktop_farm_png_new.png";
  let desktopImageWebp =
    URL_CONFIG.IMG_URL + "arya2/desktop_farm_webp_new.webp";

  let webpImage = URL_CONFIG.IMG_URL + "arya2/farm_image.webp";
  const location = useLocation();
  return (
    <>
      <Card
        className={`boxRadius8 boxShadow8 positionRelative   ${
          isMobile
            ? "margin16"
            : "left-right-margin-100 margin-top24 margin-bottom24 desk_card_border"
        }`}
      >
        <div className={` ${style["ImageHeight"]} boxRadius8 positionRelative`}>
          <img
            src={
              isWebpSupported()
                ? !isMobile
                  ? desktopImageWebp
                  : webpImage
                : !isMobile
                ? desktopImage
                : pngImage
            }
            alt=""
            className={` ${style["ImageHeight"]} w-100 boxRadius8`}
          />
          <div
            className={`text-center backgroundWhite boxShadow8 borderRadiusBottom positionAbsolute width-100  ${style["backGroundCSS"]} ${style["positionBottom"]}`}
          >
            <HeadLines
              className={`${
                isMobile
                  ? "font-size18 line-height21 padding-bottom16"
                  : `${style["headingCSS"]} margin-bottom12`
              }  font-weight500 `}
              text="India’s Largest Integrated Grain Commerce Platform"
            />
            <Button
              onClick={() => {
                eventTracker("event", CREATE_ACCOUNT_CLICKED, {
                  pagename:
                    location.pathname === "/" ? "homepage" : location.pathname,
                });
                props.setShow(true);
              }}
              title="Create arya.ag Account"
              className={`textColorWhite ${style["border-radius4"]} ${
                style["padding-leftright24"]
              }  backgroundDarkGrey padding-top8 padding-bottom8 ${
                isMobile ? "" : style["width300"]
              }`}
            />
          </div>
        </div>
      </Card>
    </>
  );
};
export default CreateAccountWidget;
